import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import {
  SectionPager
} from 'app/components/section-pager/section-pager';

/**
 * If the current section is the selected one, it's domains will be rendered as a section
 * in addition to beeing the active/selected one
 */
export function withRenderActiveSection() {
  return (
    WrappedComponent: React.ComponentClass<any> | React.FC<React.PropsWithChildren<{}>>
  ): React.FC<React.PropsWithChildren<{}>> => {
    return (props: any) => {

      const page = (sectionId: number) => {
        navigate.toSection(sectionId);
        props.onSelectDocumentItem(null);
        scrollToTop();
      };

      const handlePrevious = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        page(props.previousSection.id);
      };

      const handleNext = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        page(props.nextSection.id);
      };

      const {
          activeSection,
          componentId,
          expandAll,
          nextSection,
          previousSection,
          previousButtonTooltip,
          nextButtonTooltip
      } = props;

      const isActive = activeSection === Number(componentId);
      const shouldRender = expandAll || isActive;

      return shouldRender ? (
          <>
            <WrappedComponent {...props} />
            <SectionPager
              onNext={handleNext}
              onPrevious={handlePrevious}
              nextButtonTooltip={nextButtonTooltip}
              nextSection={nextSection}
              previousSection={previousSection}
              previousButtonTooltip={previousButtonTooltip}
              hide={expandAll}
            />
          </>
        ) : null;
      };
    };
  }
